import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { initialDataList } from '@interfaces/commonInterfaces'
import moment from 'moment'

export interface OrderState {
  invoiceList?: any
  reloadInvoiceList?: string | null
  
}

const initialState: OrderState = {
  invoiceList: initialDataList,
  reloadInvoiceList: null,
}

export const orderDucks = createSlice({
  name: 'order',
  initialState,
  reducers: {
    getListInvoice: (state: RootState, action: PayloadAction<any>) => {
      state.invoiceList = { loading: true, queryStr: action.payload }
    },
    getListInvoiceSuccess: (state, action: PayloadAction<any>) => {
      state.invoiceList = { loading: false, ...action.payload }
    },
    getListInvoiceFail: (state, action: PayloadAction<any>) => {
      state.invoiceList = { loading: false, ...action.payload }
    },
    setReloadInvoiceList: (state) => {
      state.reloadInvoiceList = String(moment())
    },


  },
})

// Action creators are generated for each case reducer function
export const {
  getListInvoice,
  getListInvoiceSuccess,
  getListInvoiceFail,
  setReloadInvoiceList,

} = orderDucks.actions

export default orderDucks.reducer
